// extracted by mini-css-extract-plugin
export default {"catalog_item":"KatalogItem_catalog_item__epq2P","image":"KatalogItem_image__e3Rjq"};